import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { OuterLayout } from '../styles/Layouts';
import { useIsMedium } from '../styles/Layouts';
import bg from '../assets/bg.svg';
import image1 from '../assets/avatar1.svg';
import image2 from '../assets/avatar2.svg';
import image3 from '../assets/avatar3.svg';
import image4 from '../assets/avatar4.svg';
import image5 from '../assets/avatar5.svg';

function OurTeam() {
  const isMedium = useIsMedium();
  return (
    <OurTeamStyled
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0, transition: { duration: 0.5 } }}
    >
      <OuterLayout>
        <div className="team-container">
          <div className="left-items">
            <h2 className="primary-heading">Our Team</h2>
            <p className="t-para">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptate sed ducimus numquam adipisci vitae
              suscipit nulla assumenda facilis, tempore necessitatibus corrupti! Veniam, modi! Dolorum, possimus.
            </p>
            <p className="t-para">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptate sed ducimus numquam adipisci vitae
              suscipit nulla assumenda facilis, tempore necessitatibus corrupti! Veniam, modi! Dolorum, possimus.
            </p>
          </div>
          <div className="right-items">
            <div className="image-container">
              <motion.div
                className="card-img"
                animate={
                  isMedium
                    ? {
                        scale: [1, 2.4, 1, 1.6, 2.6],
                        y: [0, -200, 200, -200],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '15', yoyo: Infinity },
                      }
                    : {
                        scale: [1, 2.4, 1, 1.6, 2.6],
                        y: [0, -300, 100, -300],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '15', yoyo: Infinity },
                      }
                }
              >
                <img src={image1} alt="" />
              </motion.div>

              <motion.div
                className="card-img"
                animate={
                  isMedium
                    ? {
                        scale: [1, 1.6, 2, 1, 2.4],
                        y: [200, -200, 200, -200],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '12', yoyo: Infinity },
                      }
                    : {
                        scale: [1, 1.6, 2, 1, 2.4],
                        y: [200, -300, 200, -300],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '12', yoyo: Infinity },
                      }
                }
              >
                <img src={image2} alt="" />
              </motion.div>
              <motion.div
                className="card-img"
                animate={
                  isMedium
                    ? {
                        scale: [1, 1.2, 2, 1, 2.4],
                        y: [150, -200, 200, -200],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '13', yoyo: Infinity },
                      }
                    : {
                        scale: [1, 1.2, 2, 1, 2.4],
                        y: [150, -300, 200, -300],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '13', yoyo: Infinity },
                      }
                }
              >
                <img src={image3} alt="" />
              </motion.div>

              <motion.div
                className="card-img"
                animate={
                  isMedium
                    ? {
                        scale: [1, 2.2, 1.4, 2, 1.4],
                        y: [-150, -200, 200, -200],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '10', yoyo: Infinity },
                      }
                    : {
                        scale: [1, 2.2, 1.4, 2, 1.4],
                        y: [-150, -300, 200, -300],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '10', yoyo: Infinity },
                      }
                }
              >
                <img src={image4} alt="" />
              </motion.div>

              <motion.div
                className="card-img"
                animate={
                  isMedium
                    ? {
                        scale: [1, 1.2, 2.4, 2, 1.8],
                        y: [-50, -200, 200, -200],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '11', yoyo: Infinity },
                      }
                    : {
                        scale: [1, 1.2, 2.4, 2, 1.8],
                        y: [-50, -300, 200, -300],
                        rotate: [0, 360, 0, 360],
                        transition: { duration: '11', yoyo: Infinity },
                      }
                }
              >
                <img src={image5} alt="" />
              </motion.div>
            </div>
          </div>
        </div>
      </OuterLayout>
    </OurTeamStyled>
  );
}

const OurTeamStyled = styled(motion.div)`
  min-height: 100vh;
  width: 100%;
  padding-top: 16rem;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: 100%;

  .team-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    @media screen and (max-width: 1347px) {
      grid-template-columns: repeat(1, 1fr);
      display: inherit;
    }
  }
  .left-items {
    .t-para {
      padding: 2rem 0;
      color: #fff;
    }
  }
  .right-items {
    padding-right: 2rem;
    padding-top: 8rem;
    position: relative;
    @media screen and (max-width: 1347px) {
      padding-top: 10rem;
      padding-right: 0rem;
    }
    .image-container {
      display: flex;
      align-items: center;
      justify-content: center;
      @media screen and (max-width: 1347px) {
        transform: scale(0.6);
      }

      img {
        padding: 1rem;
      }
    }
  }
`;

export default OurTeam;
